import { Component } from 'react';
import Collapsible from 'react-collapsible';
import Inline from '../Inline';
import MinimalButton from '../MinimalButton';
import FontAwesomeIcon from './FontAwesomeIcon';
import { Button } from 'devextreme-react';
// import Space from '../components/Space';

class CollapsibleBox extends Component {
    state = {
        opened: this.props.opened !== false
    };

    render() {
        const CollapsibleComp = Collapsible?.default ?? Collapsible?.Collapsible ?? Collapsible;

        const isValid = c => typeof c === 'function' || (typeof c === 'object' && c !== null && (c.$$typeof || c.render));
        if (!isValid(CollapsibleComp) || !isValid(Inline) || !isValid(FontAwesomeIcon)) {
            console.error('CollapsibleBox: invalid component types:', {
                CollapsibleComp, Inline, FontAwesomeIcon
            });
            // render a non-crashing fallback
            return (
                <div style={{ padding: '1rem', background: 'pink', borderRadius: '1rem' }}>
                    <b>CollapsibleBox: invalid component detected (see console)</b>
                </div>
            );
        }

        return (
            <CollapsibleComp open={this.state.opened} width={this.props.width ?? '100%'} className={this.props.className}
                containerElementProps={{
                    style: {
                        direction: this.props.rtlEnabled === false || this.props.ltr === true ? 'ltr' : 'rtl',
                        ...this.props.style
                    }
                }}
                triggerSibling={
                    <Inline spacing='1rem' rtlEnabled={this.props.rtlEnabled} width={this.props.width ?? '100%'}
                        style={{
                            background: this.props.style?.backgroundColor ?? this.props.background ?? 'whitesmoke', //marginTop: '1rem',
                            padding: '1rem',// alignItems: 'center',
                            borderRadius: this.state.opened ? '1rem 1rem 0 0' : '1rem',
                            ...this.props.headerStyle
                        }}
                        farItems={
                            !this.props.farItems
                                ? undefined
                                : !Array.isArray(this.props.farItems) || this.props.farItems.length < 2
                                    ? <div style={{ margin: '1rem' }}>{this.props.farItems}</div>
                                    : this.props.farItems
                        }
                    >
                        {/* <MinimalButton icon={this.state.opened ? 'chevronup' : 'chevrondown'}
                            onClick={() => this.setState({ opened: !this.state.opened })}
                        /> 
                        */}

                        {this.props.hideCollapseButton !== true &&
                            <FontAwesomeIcon icon={this.state.opened ? 'chevron-up' : 'chevron-down'}
                                onClick={() => this.setState({ opened: !this.state.opened })}
                            />
                        }

                        <div style={{
                            height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '700',
                            overflow: 'hidden',
                            ...this.props.titleStyle
                        }} className={this.props.titleClass}
                        >
                            {this.props.title}
                            {!this.state.opened && this.props.summary}
                            {/* {this.props.children?.length > 0 ? this.props.children.filter(x => x.type.name === 'Title') : <></>} */}
                        </div>
                    </Inline>
                }

                onOpening={e => {
                    this.setState({
                        borderRadius: '1rem 1rem 0 0',
                        icon: 'chevronup'
                    });
                    this.props.onOpening?.(e);
                }}

                onClosing={e => {
                    this.setState({
                        borderRadius: '1rem',
                        icon: 'chevrondown'
                    });
                    this.props.onClosing?.(e);
                }}

                {...this.props.collapsibleProps}
            >
                <div style={{
                    borderRadius: this.state.open ? '0 0 1rem 1rem' : '1rem', marginTop: '0',
                    //width: `${this.props.width ?? '100%'}`,
                    width: '100%',
                    padding: '0 1rem 1rem 1rem',
                    ...this.props.bodyStyle,
                }}
                    className={this.props.bodyClass}
                >
                    {/* {this.props.body}
                    {...this.props.children} */}
                </div>
            </CollapsibleComp>
        );
    }
}

export default CollapsibleBox;